var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-tree',{ref:"mainTree",attrs:{"data":_vm.treeData,"show-checkbox":"","node-key":_vm.nodeKey,"props":_vm.treeProps,"default-checked-keys":_vm.checkedData}})}
var staticRenderFns = []

export { render, staticRenderFns }